<template>
    <v-container grid-list-md>
        <br />
        <div>
            <v-card class="handbook-searchOptions_card">
                <v-layout row wrap>
                    <v-flex xs12>
                        <v-container class="handbook-toolbar" ma-0 pa-2 py-xs-0>
                            <v-layout row wrap>
                                <v-flex xs12 md5 lg6>
                                    <v-text-field v-model="SELECTED_SEARCH" append-icon="search" :label="nameSearchLabel" v-on:keyup="FILTER_SEARCH" single-line hide-details></v-text-field>
                                </v-flex>
                                <v-flex xs12 md2 lg2>
                                    <v-btn-toggle v-model="SELECTED_GENDER" class="transparent handbook_toggleButton" @change="FILTER_GENDER">
                                        <v-btn class="handbook_button" :value="Gender[0]" color="secondary">
                                            <span class="long-button-text">Women</span>
                                            <span class="short-button-text">Women</span>
                                        </v-btn>
                                        <v-btn class="handbook_button" :value="Gender[1]" color="secondary">
                                            <span class="long-button-text">Men</span>
                                            <span class="short-button-text">Men</span>
                                        </v-btn>
                                    </v-btn-toggle>
                                </v-flex>
                                <v-flex xs12 md3 lg2 class="handbook-leftDivider_hideSmall">
                                    <v-btn-toggle v-model="SELECTED_MPORSENATOR" class="transparent handbook_toggleButton" @change="FILTER_MPORSENATOR" multiple>
                                        <v-btn class="handbook_button" :value="MPorSenator[1]" :color="REPS_COLOUR">
                                            <span class="long-button-text chamberButton">{{MPorSenator[1]}}</span>
                                            <span class="short-button-text chamberButton">{{MPorSenator[1]}}</span>
                                        </v-btn>
                                       
                                        <v-btn class="handbook_button" :value="MPorSenator[0]" :color="SENATE_COLOUR">
                                            <span class="long-button-text chamberButton">{{MPorSenator[0]}}</span>
                                            <span class="short-button-text chamberButton">{{MPorSenator[0]}}</span>
                                        </v-btn>
                                    </v-btn-toggle>
                                </v-flex>
                                <v-flex xs6 md1>
                                    <v-btn-toggle v-model="SELECTED_SEARCH_MORE" class="handbook_toggleButton" single>
                                        <v-btn value="1" style="min-width:16px" color="primary" class="handbook_iconButton">
                                            <v-icon>filter_list_alt</v-icon><span class="hideButtonText">&nbsp;{{moreButtonText}}</span>
                                        </v-btn>
                                    </v-btn-toggle>
                                </v-flex>
                                <v-flex xs6 md1 class="handbook-leftDivider_hideSmall">
                                    <v-btn style="min-width:16px" v-on:click="CLEAR_SEARCH" color="primary" class="handbook_iconButton">
                                        <v-icon class="buttonIcon">cancel</v-icon><span class="hideButtonText">&nbsp;Clear</span>
                                    </v-btn>
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-flex>
                    <v-flex :class="searchMore" xs12>
                        <v-container class="handbook-toolbar" ma-0 pa-2 py-xs-0>
                            <v-layout row wrap>
                                <v-flex xs12 md4>
                                    <v-autocomplete :items="this.$store.getters.GET_PARLIAMENTS_ORDERED"
                                                    item-text="Name"
                                                    item-value="PID"
                                                    :label="parliamentSelectLabel"
                                                    v-model="SELECTED_PARLIAMENTS"
                                                    v-on:change="FILTER_PARLIAMENTS"
                                                    :filter="FILTER_PARLIAMENT_OPTIONS"
                                                    :search-input.sync="parliamentSearchInput"
                                                    auto-select-first multiple small-chips deletable-chips>
                                        <template v-slot:selection="{ item, index }">
                                            <v-chip @input="deleteParliamentSelectionItem(item.PID)" small close v-if="index == 0">{{item.Name}}</v-chip>
                                            <v-chip small v-if="index == 1">+ {{SELECTED_PARLIAMENTS.length - 1}} more</v-chip>
                                        </template>
                                        <template v-slot:prepend-item v-if="this.$store.getters.GET_PARLIAMENTS_ORDERED.length > 0 && !this.parliamentSearchInput">
                                            <v-list-tile v-on:click="CLICK_CURRENTPARLIAMENT" :value="currentParliamentValue" ripple>
                                                <v-list-tile-action>
                                                    <v-icon>{{currentParliamentIcon}}</v-icon>
                                                </v-list-tile-action>
                                                <v-list-tile-content>
                                                    <v-list-tile-title>Current Parliament</v-list-tile-title>
                                                </v-list-tile-content>
                                            </v-list-tile>
                                            <v-divider class="mt-2"></v-divider>
                                        </template>
                                    </v-autocomplete>
                                </v-flex>
                                <v-flex xs12 md4 class="handbook-leftDivider_hideSmall">
                                    <v-autocomplete :items="PARTIES"
                                                    item-text="PrimaryName"
                                                    item-value="PrimaryName"
                                                    :label="partySelectLabel"
                                                    v-model="SELECTED_PARTIES"
                                                    v-on:change="FILTER_PARTIES"
                                                    :filter="FILTER_PARTY_OPTIONS"
                                                    :search-input.sync="partySearchInput"
                                                    auto-select-first multiple small-chips deletable-chips>
                                        <template v-slot:selection="{ item, index }">
                                            <v-chip @input="deletePartySelectionItem(item.PrimaryName)" small close v-if="index == 0">{{item.PrimaryName}}</v-chip>
                                            <v-chip small v-if="index == 1">+ {{SELECTED_PARTIES.length - 1}} more</v-chip>
                                        </template>
                                        <template v-slot:prepend-item v-if="this.$store.getters.GET_PARTIES.length > 0 && !this.partySearchInput && this.SELECTED_PARLIAMENTS.length === 0">
                                            <v-list-tile v-on:click="CLICK_CURRENTPARTIES(currentParty.PrimaryName)" :value="SELECTED_PARTIES.includes(currentParty.PrimaryName) 
                                                ? currentParty.PrimaryName : false" v-for="currentParty in currentParties" :key="currentParty.PrimaryName" ripple>
                                                <v-list-tile-action>
                                                    <v-icon>{{currentPartyIcon(currentParty.PrimaryName)}}</v-icon>
                                                </v-list-tile-action>
                                                <v-list-tile-content>
                                                    <v-list-tile-title>{{currentParty.PrimaryName}}</v-list-tile-title>
                                                </v-list-tile-content>
                                            </v-list-tile>
                                            <v-divider class="mt-2"></v-divider>
                                        </template>
                                    </v-autocomplete>
                                </v-flex>
                                <v-flex xs12 md4 class="handbook-leftDivider_hideSmall">
                                    <v-autocomplete :items="this.$store.getters.GET_STATES"
                                                    item-text="Name" item-value="Abbrev"
                                                    :label="stateSelectLabel"
                                                    v-model="SELECTED_STATES"
                                                    v-on:change="FILTER_STATES"
                                                    :filter="FILTER_STATE_OPTIONS"
                                                    :search-input.sync="stateSearchInput"
                                                    multiple small-chips deletable-chips>
                                            <template v-slot:selection="{ item, index }">
                                                <v-chip @input="deleteStateSelectionItem(item.Abbrev)" small close v-if="index == 0">{{item.Name}}</v-chip>
                                                <v-chip small v-if="index == 1">+ {{SELECTED_STATES.length - 1}} more</v-chip>
                                            </template>
                                    </v-autocomplete>
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-flex>
                    <v-flex :class="searchMore" xs12>
                        <v-container class="handbook-toolbar" ma-0 pa-2 py-xs-0>
                            <v-layout row wrap>
                                <v-flex xs12 md4>
                                    <v-autocomplete :items="this.$store.getters.GET_ELECTORATES"
                                                    item-text="Electorate" item-value="Electorate"
                                                    :label="electorateSelectLabel"
                                                    v-model="SELECTED_ELECTORATES"
                                                    v-on:change="FILTER_ELECTORATES"
                                                    :filter="FILTER_ELECTORATE_OPTIONS"
                                                    :search-input.sync="electorateSearchInput"
                                                    multiple small-chips deletable-chips>
                                        <template v-slot:selection="{ item, index }">
                                            <v-chip @input="deleteElectorateSelectionItem(item.Electorate)" small close v-if="index == 0">{{item.Electorate}}</v-chip>
                                            <v-chip small v-if="index == 1">+ {{SELECTED_ELECTORATES.length - 1}} more</v-chip>
                                        </template>
                                    </v-autocomplete>
                                </v-flex>
                                <v-flex xs12 md4 class="handbook-leftDivider_hideSmall">
                                    <v-text-field v-model="SELECTED_SEARCH_POB" append-icon="search" :label="pobSearchLabel" v-on:keyup="FILTER_SEARCH_POB" single-line hide-details browser-autocomplete="off"></v-text-field>
                                </v-flex>
                                <v-flex xs12 md4 class="handbook-leftDivider_hideSmall">
                                    <v-text-field v-model="SELECTED_SEARCH_OCCUPATIONS" append-icon="search" :label="occupationsSearchLabel" v-on:keyup="FILTER_SEARCH_OCCUPATIONS" single-line hide-details browser-autocomplete="off"></v-text-field>
                                </v-flex>

                            </v-layout>
                        </v-container>

                    </v-flex>

                    <v-flex :class="searchMore" xs12>
                        <v-container class="handbook-toolbar" ma-0 pa-2 py-xs-0>
                            <v-layout row wrap>
                                <v-flex xs12 md4>
                                    <v-text-field v-model="SELECTED_SEARCH_QUALIFICATIONS" append-icon="search" :label="qualificationsSearchLabel" v-on:keyup="FILTER_SEARCH_QUALIFICATIONS" single-line hide-details browser-autocomplete="off"></v-text-field>
                                </v-flex>
                                <v-flex xs12 md4 class="handbook-leftDivider_hideSmall">
                                    <v-autocomplete :items="PARLIAMENTARY_POSITIONS"
                                                    :label="officeholdersSearchLabel"
                                                    v-model="SELECTED_OFFICEHOLDERS"
                                                    v-on:change="FILTER_OFFICEHOLDERS"
                                                    :search-input.sync="officeHolderSearchInput"
                                                    multiple small-chips deletable-chips>
                                        <template v-slot:selection="{ item, index }">
                                            <v-chip class="text-truncate" @input="deleteParliamentaryOfficeSelectionItem(item)" small close v-if="index == 0">{{item}}</v-chip>
                                            <v-chip small v-if="index == 1">+ {{SELECTED_OFFICEHOLDERS.length - 1}} more</v-chip>
                                        </template>
                                    </v-autocomplete>
                                </v-flex>
                                <v-flex xs12 md4 class="handbook-leftDivider_hideSmall">
                                    <v-combobox :items="filteredHonours"
                                                :label="honoursSearchLabel"
                                                v-model="SELECTED_SEARCH_HONOURS"
                                                v-on:change="FILTER_HONOURS"
                                                :search-input.sync="honoursSearchInput"
                                                small-chips deletable-chips>
                                       <template v-slot:selection="{ item, index }">
                                            <v-chip @input="deleteHonourSelectionItem(item)" small close v-if="index == 0">
                                                <span class="text-truncate">{{item}}</span>
                                            </v-chip>
                                            <v-chip small v-if="index == 1">+ {{SELECTED_SEARCH_HONOURS.length - 1}} more</v-chip>
                                        </template>
                                    </v-combobox>
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-flex>

                </v-layout>
            </v-card>

            <template>
                <v-card v-if="!this.$store.getters.GET_APPLICATION_INIT_LOADED || loading">
                    <v-container fluid>
                        <v-layout row wrap>
                            <v-flex xs12>
                                <div class="loader"></div>
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-card>
            </template>

            <v-layout v-if="this.$store.getters.GET_APPLICATION_INIT_LOADED && !loading">
                <v-flex xs12>
                    <v-card class="handbook-iteratorCard" color="grey lighten-4">
                        <v-data-iterator :items="RECORDS1"
                                         :rows-per-page-items="ROWS_TILEITEMS"
                                         :pagination.sync="PAGINATION"
                                         v-on:update:pagination="UPDATE_PAGINATION"
                                         :total-items="totalItems"
                                         content-tag="v-layout" row wrap>

                            <template v-slot:item="props" loading-text="Data loading, please wait" no-results="No criterion matches found">
                                <ParliamentarianBrief :PARLIAMENTARIAN="props"></ParliamentarianBrief>
                            </template>

                            <template v-slot:no-data>
                                <v-alert :value="true" color="info" outline icon="info">No results found</v-alert>
                            </template>

                            <template v-slot:no-results>
                                <v-alert :value="true" color="info" outline icon="info">
                                    Your search for "{{ SELECTED_SEARCH }}" found no results.
                                </v-alert>
                            </template>
                        </v-data-iterator>
                    </v-card>
                </v-flex>
            </v-layout>

            <v-layout row wrap>
                <v-flex xs2 offset-xs10>
                    <v-btn class="csvButton" color="primary"  v-on:keyup.enter="EXPORT_PARLIAMENTARIANS_CSV">
                        <v-icon aria-hidden="true" :class="csvDownloadClass">{{csvDownloadIcon}}</v-icon>
                        <span v-on:click="EXPORT_PARLIAMENTARIANS_CSV">&nbsp;Download as CSV</span>
                    </v-btn>
                </v-flex>
            </v-layout>
        </div>
    </v-container>
</template>

<script>
    import ParliamentarianBrief from '@/components/ParliamentarianBrief.vue'
    import axios from 'axios';
    window.Handbook = window.Handbook || {}
    const apiUri = window.Handbook.ApiUri || "https://localhandbookapi.aph.gov.au/";
    axios.defaults.baseURL = apiUri;
    import _ from 'lodash';

    export default {

        components: {
            ParliamentarianBrief
        },

        data() {
            return {
                loading: true,
                currentFilterURL: '',
                initialLoad: true,
                parliamentarians: [],
                HONOURS: [],
                PARLIAMENTARY_POSITIONS: [],
                RECORDS1: [],
                SELECTED_PARLIAMENTS: [],
                SELECTED_PARTIES: [],
                SELECTED_STATES: [],
                SELECTED_ELECTORATES: [],
                SELECTED_GENDER: [],
                SELECTED_MPORSENATOR: [],
                SELECTED_SEARCH: '',
                SELECTED_SEARCH_POB: '',
                SELECTED_SEARCH_OCCUPATIONS: '',
                SELECTED_SEARCH_QUALIFICATIONS: '',
                SELECTED_OFFICEHOLDERS: '',
                SELECTED_SEARCH_HONOURS: '',
                SELECTED_SEARCH_MORE: '',

                ROWS_TILEITEMS: [9, 18, 36, {
                    "text": "$vuetify.dataIterator.rowsPerPageAll",
                    "value": -1
                }],
                totalItems: 0,
                PAGINATION: {
                    rowsPerPage: this.$route.query.pagesize ? parseInt(this.$route.query.pagesize) : 36,
                    page: this.$route.query.page ? parseInt(this.$route.query.page) : 1
                },
                PARTIES: [],
                PARTIESCOPY: [],
                currentParties: [],
                REPS_COLOUR: this.$store.state.COLOUR_REPRESENTATIVES,
                SENATE_COLOUR: this.$store.state.COLOUR_SENATE,

                MPorSenator: ['Senator', 'Member'],
                Gender: ['Female', 'Male'],
                parliamentSearchInput: '',
                partySearchInput: '',
                electorateSearchInput: '',
                stateSearchInput: '',
                officeHolderSearchInput: '',
                honoursSearchInput: '',
                csvDownloading: false
            }
        },

        mounted() {

            if (this.$route.query.parliaments) {
                this.SELECTED_PARLIAMENTS = this.$route.query.parliaments.split(',').map(p => parseInt(p));
            }
            if (this.$route.query.parties) {
                this.SELECTED_PARTIES = this.$route.query.parties.split(',');
            }
            if (this.$route.query.states) {
                this.SELECTED_STATES = this.$route.query.states.split(',');
            }
            if (this.$route.query.electorates) {
                this.SELECTED_ELECTORATES = this.$route.query.electorates.split(',');
            }
            if (this.$route.query.gender) {
                this.SELECTED_GENDER = this.$route.query.gender;
            }
            if (this.$route.query.mporsenator) {
                this.SELECTED_MPORSENATOR = this.$route.query.mporsenator.split(',');
            }
            if (this.$route.query.q) {
                this.SELECTED_SEARCH = this.$route.query.q;
            }
            if (this.$route.query.pob) {
                this.SELECTED_SEARCH_POB = this.$route.query.pob;
            }
            if (this.$route.query.quals) {
                this.SELECTED_SEARCH_QUALIFICATIONS = this.$route.query.quals;
            }
            if (this.$route.query.occs) {
                this.SELECTED_SEARCH_OCCUPATIONS = this.$route.query.occs;
            }
            if (this.$route.query.office) {
                this.SELECTED_OFFICEHOLDERS = this.$route.query.office.split(',');
            }
            if (this.$route.query.honours) {
                this.SELECTED_SEARCH_HONOURS = this.$route.query.honours;
            }
            this.FILTER_INDIVIDUALS();
        },

        created() {
            this.loadFilters();
            this.loadParties();
        },

        methods: {
            deleteParliamentSelectionItem(item) {
                this.SELECTED_PARLIAMENTS = this.SELECTED_PARLIAMENTS.filter(find => find !== item);
                this.FILTER_INDIVIDUALS();
            },
            deletePartySelectionItem(item) {
                this.SELECTED_PARTIES = this.SELECTED_PARTIES.filter(find => find !== item);
                this.FILTER_INDIVIDUALS();
            },
            deleteStateSelectionItem(item) {
                this.SELECTED_STATES = this.SELECTED_STATES.filter(find => find !== item);
                this.FILTER_INDIVIDUALS();
            },
            deleteElectorateSelectionItem(item) {
                this.SELECTED_ELECTORATES = this.SELECTED_ELECTORATES.filter(find => find !== item);
                this.FILTER_INDIVIDUALS();
            },
            deleteParliamentaryOfficeSelectionItem(item) {
                this.SELECTED_OFFICEHOLDERS = this.SELECTED_OFFICEHOLDERS.filter(find => find !== item);
                this.FILTER_INDIVIDUALS();
            },
            deleteHonourSelectionItem(item) {
                this.SELECTED_SEARCH_HONOURS = this.SELECTED_SEARCH_HONOURS.filter(find => find !== item);
                this.FILTER_INDIVIDUALS();
            },
            EXPORT_PARLIAMENTARIANS_CSV() {

                this.$gtag.event('parliamentarians download csv', {
                    'event_category': 'downloads',
                    'event_label': 'parliamentarians search csv download',
                    'value': 1
                });

                this.csvDownloading = true;

                var url = `individuals?$orderby=FamilyName,GivenName&$select=PHID,DisplayName,MPorSenator,Gender,State,StateAbbrev,SenateState,Electorate,Party,RepresentedParties,RepresentedStates,RepresentedElectorates,RepresentedParliaments,DateOfBirth,PlaceOfBirth,StateOfBirth,CountryOfBirth,DateOfDeath,PlaceOfDeath,StateOfDeath,ServiceHistory_Start,ServiceHistory_End,ServiceHistory_Duration,Occupations,SecondaryOccupations,Qualifications,Honours,ParliamentaryPositions,Age`;

                if (this.currentFilterURL != ''){
                    url = this.currentFilterURL;
                    url = url.replace(`&$top=${this.PAGINATION.rowsPerPage}`, '');
                }

                axios.get(`api/${url}`).then(response => {
                    const thisTemp = response.data.value;
                    let OBJ_records = [];
                    let index = 0;
                    let headers = ['Name', 'Date of Birth', 'Date of Death', 'Place of Birth', 'Place of Death', 'Gender', 'Country of Birth', 'State of Birth', 'State of Death', 'Party: Most Recent', 'Electorate: Most Recent', 'Senate State', 'State: Most Recent', 'MP or Senator', 'Service History: First', 'Service History: Last', 'Service History: Duration', 'Age_String'];
                    let filename = 'parliamentarians';

                    //  then we progressively build up the  exportOBJ
                    for (index = 0; index < thisTemp.length; ++index) {
                        let endDate = this.formatDate(thisTemp[index].ServiceHistory_End, '', 'YYYY-MM-DD');
                        if (endDate === this.$moment().format('YYYY-MM-DD')) {
                            endDate = 'Current';
                        }

                        let dob = this.formatDate(thisTemp[index].DateOfBirth, '', 'YYYY-MM-DD');
                        let dod = this.formatDate(thisTemp[index].DateOfDeath, '', 'YYYY-MM-DD');
                        let startDate = this.formatDate(thisTemp[index].ServiceHistory_Start, '', 'YYYY-MM-DD');

                        let age = 0;
                        if (thisTemp[index].Age > 0) {
                            age = (thisTemp[index].Age * 0.002738).toFixed(1);
                        }

                        OBJ_records.push({
                            'Name': thisTemp[index].DisplayName
                            , 'PHID': thisTemp[index].PHID
                            , 'Date Of Birth': dob
                            , 'Place Of Birth': thisTemp[index].PlaceOfBirth
                            , 'State Of Birth': thisTemp[index].StateOfBirth
                            , 'Country Of Birth': thisTemp[index].CountryOfBirth
                            , 'Date Of Death': dod
                            , 'Place Of Death': thisTemp[index].PlaceOfDeath
                            , 'State Of Death': thisTemp[index].StateOfDeath
                            , 'Gender': thisTemp[index].Gender
                            , 'Party': thisTemp[index].RepresentedParties.join('; ')
                            , 'State': thisTemp[index].State
                            , 'Electorate': thisTemp[index].RepresentedElectorates.join('; ')
                            , 'Senate State': thisTemp[index].SenateState
                            , 'MP or Senator': thisTemp[index].MPorSenator.join(' and ')
                            , 'Service History: First': startDate
                            , 'Service History: Last': endDate
                            , 'Service History: Duration': thisTemp[index].ServiceHistory_Duration
                            , 'Age': age || 'N/A'
                        });
                    }
                    var comment = "Note that 'Service History: First' and 'Service History: Last' indicate the first and last instances of service for the entirety of that individual's Parliamentary career, and does not account for separate non-contiguous service terms."
                    this.$store.dispatch('GETCSV', { DATA: OBJ_records, HEADERS: headers, FILENAME: filename, COMMENT: comment })
                        .catch(this.showError)
                        .finally(() => this.csvDownloading = false);
                });
            },

            UPDATE_PAGINATION: function (options) {
                this.$gtag.event('parliamentarians pagination items per page', {
                    'event_category': 'filters',
                    'event_label': `items per page: ${options.rowsPerPage}`,
                    'value': 1
                });
                this.$gtag.event('parliamentarians pagination page', {
                    'event_category': 'filters',
                    'event_label': `page: ${options.page}`,
                    'value': 1
                });
            },

            // load data based on pagination and filtering
            FILTER_INDIVIDUALS: function () {
                if (this.PAGINATION.rowsPerPage === -1) {
                    this.loading = true;
                }
                const skip = (this.PAGINATION.page - 1) * this.PAGINATION.rowsPerPage;
                let filtered = false;
                let filters = [];

                // get original query string
                let query = this.$router.query || {};

                //build filter up
                let url = `individuals?$orderby=FamilyName,GivenName&$skip=${skip || 0}&$count=true`;
                // if pagination is -1, don't apply server side pagination
                if (this.PAGINATION.rowsPerPage !== -1) {
                    url += `&$top=${this.PAGINATION.rowsPerPage}`;
                }

                // store pagesize and page in query string
                query.pagesize = this.PAGINATION.rowsPerPage;

                if (this.PAGINATION.page && !(this.initialLoad && this.PAGINATION.page === 1)) {
                    query.page = this.PAGINATION.page;
                }

                let index = 0

                if (this.SELECTED_SEARCH.length >= 3) {
                    filtered = true;
                    let terms = this.SELECTED_SEARCH.split(' ');
                    const filter = terms.map(t => `contains(tolower(DisplayName),tolower('${this.replaceSpecialCharacters(t)}'))`).join(' and ');
                    filters.push(filter);
                    query.q = this.SELECTED_SEARCH
                }

                if (this.SELECTED_GENDER && this.SELECTED_GENDER.length > 0) {
                    filtered = true;
                    filters.push(`Gender eq '${this.SELECTED_GENDER}'`);
                    query.gender = this.SELECTED_GENDER;
                }

                if (this.SELECTED_MPORSENATOR.length === 1) {
                    filtered = true;
                    filters.push(`MPorSenator/any(m:m eq '${this.SELECTED_MPORSENATOR[0]}')`)
                    query.mporsenator = this.SELECTED_MPORSENATOR.join(',');
                }

                //  now we progressively expand on the empty object including Parliaments
                for (index = 0; index < this.SELECTED_PARLIAMENTS.length; ++index) {
                    filters.push(`RepresentedParliaments/any(p:p eq ${this.SELECTED_PARLIAMENTS[index]})`);
                }

                if (this.SELECTED_PARLIAMENTS.length > 0) {
                    filtered = true;
                    query.parliaments = this.SELECTED_PARLIAMENTS.join(',')
                }

                //  Now, from here down we filter down to exclude records from Parliamenterians
                for (index = 0; index < this.SELECTED_PARTIES.length; ++index) {
                    console.log(this.SELECTED_PARTIES[index].replace("'", '%27'))
                    filters.push(`RepresentedParties/any(p:p eq '${this.SELECTED_PARTIES[index].replace(/'/g, "''")}')`);
                }

                if (this.SELECTED_PARTIES.length > 0) {
                    filtered = true;
                    query.parties = this.SELECTED_PARTIES.join(',');
                }

                for (index = 0; index < this.SELECTED_STATES.length; ++index) {
                    filters.push(`RepresentedStates/any(s:s eq '${this.SELECTED_STATES[index]}')`)
                }

                if (this.SELECTED_STATES.length > 0) {
                    filtered = true;
                    query.states = this.SELECTED_STATES.join(',');
                }

                for (index = 0; index < this.SELECTED_ELECTORATES.length; ++index) {
                    filters.push(`RepresentedElectorates/any(s:s eq '${this.SELECTED_ELECTORATES[index]}')`)
                }

                if (this.SELECTED_ELECTORATES.length > 0) {
                    filtered = true;
                    query.electorates = this.SELECTED_ELECTORATES.join(',');
                }

                if (this.SELECTED_SEARCH_POB.length >= 3) {
                    filtered = true;
                    filters.push(`(contains(tolower(PlaceOfBirth), tolower('${this.replaceSpecialCharacters(this.SELECTED_SEARCH_POB)}')) or contains(tolower(CountryOfBirth),tolower('${this.replaceSpecialCharacters(this.SELECTED_SEARCH_POB)}')))`);
                    query.pob = this.SELECTED_SEARCH_POB
                }

                if (this.SELECTED_SEARCH_OCCUPATIONS.length >= 3) {
                    filtered = true;
                    filters.push(`(Occupations/any(o:contains(tolower(o), tolower('${this.replaceSpecialCharacters(this.SELECTED_SEARCH_OCCUPATIONS)}'))) or SecondaryOccupations/any(o:contains(tolower(o), tolower('${this.replaceSpecialCharacters(this.SELECTED_SEARCH_OCCUPATIONS)}'))))`)
                    query.occs = this.SELECTED_SEARCH_OCCUPATIONS
                }

                if (this.SELECTED_SEARCH_QUALIFICATIONS.length >= 3) {
                    filtered = true;
                    filters.push(`Qualifications/any(q:contains(tolower(q), tolower('${this.replaceSpecialCharacters(this.SELECTED_SEARCH_QUALIFICATIONS)}')))`);
                    query.quals = this.SELECTED_SEARCH_QUALIFICATIONS
                }

                for (index = 0; index < this.SELECTED_OFFICEHOLDERS.length; ++index) {
                    filters.push(`ParliamentaryPositions/any(p:p eq '${this.replaceSpecialCharacters(this.SELECTED_OFFICEHOLDERS[index])}')`);
                }

                if (this.SELECTED_OFFICEHOLDERS.length > 0) {
                    filtered = true;
                    query.office = this.SELECTED_OFFICEHOLDERS.join(',');
                }

                if (this.SELECTED_SEARCH_HONOURS && this.SELECTED_SEARCH_HONOURS.length > 0) {
                    filtered = true;
                    filters.push(`Honours/any(h:contains(tolower(h),tolower('${this.replaceSpecialCharacters(this.SELECTED_SEARCH_HONOURS)}')))`);
                    query.honours = this.SELECTED_SEARCH_HONOURS
                }

                if (filtered) {
                    let filterString = filters.join(' and ');
                    url += `&$filter=${filterString}`;
                }

                url += `&$select=PHID,DisplayName,MPorSenator,Gender,State,StateAbbrev,SenateState,Electorate,Party,RepresentedParties,RepresentedStates,RepresentedElectorates,RepresentedParliaments,DateOfBirth,PlaceOfBirth,StateOfBirth,CountryOfBirth,DateOfDeath,PlaceOfDeath,StateOfDeath,ServiceHistory_Start,ServiceHistory_End,ServiceHistory_Duration,Occupations,SecondaryOccupations,Qualifications,Honours,ParliamentaryPositions,Age`;
                this.currentFilterURL = url;
                axios.get(`api/${url}`).then(response => {
                    this.parliamentarians = response.data.value;
                    this.totalItems = response.data['@odata.count'];
                    this.RECORDS1 = this.parliamentarians;

                    // on initial load, have to reset the page number to what it was before
                    if (this.initialLoad && this.$route.query.page) {
                        this.$nextTick().then(() => {
                            this.$set(this.PAGINATION, 'page', parseInt(this.$route.query.page));
                            this.initialLoad = false;
                        });
                    }

                    if (Object.keys(query).length > 0) {
                        history.replaceState({}, null, this.$route.path + '?' + Object.keys(query).map(key => { return (key + '=' + query[key]) }).join('&'));
                    } else {
                        history.replaceState({}, null, this.$route.path);
                    }
                    this.loading = false;
                });
            },

            loadFilters() {
                const honoursUrl = 'recordsofservice?$filter=ROSTypeID%20eq%2014&$orderby=Text1&$select=Text1';
                const parliamentaryPositionsUrl = 'recordsofservice?$filter=ROSTypeID%20eq%208&$orderby=Value1&$select=Value1';

                axios.get(`api/${honoursUrl}`).then(response => {
                    this.HONOURS = [...new Set(response.data.value.map(h => h.Text1))];
                });
                axios.get(`api/${parliamentaryPositionsUrl}`).then(response => {
                    this.PARLIAMENTARY_POSITIONS = [...new Set(response.data.value.map(p => p.Value1))];
                })
            },
            loadParties() {
                this.loading = true;
                const url ="partiesdata/parties";
                    axios.get(`api/${url}`).then((response) => {
                    this.PARTIES = response.data;
                    this.PARTIESCOPY = response.data;
                    this.currentParties = this.PARTIES.filter(p => p.IsCurrent)
                });
            },

            CLEAR_SEARCH: function () {
                // have to swallow this navigation error since it will always throw an error navigating to the same component
                this.$router.replace({}).catch(() => { });
                this.SELECTED_PARLIAMENTS = []
                this.SELECTED_PARTIES = [];
                this.SELECTED_STATES = [];
                this.SELECTED_ELECTORATES = [];
                this.SELECTED_GENDER = [];
                this.SELECTED_MPORSENATOR = [];
                this.SELECTED_OFFICEHOLDERS = [];
                this.SELECTED_SEARCH = '';
                this.SELECTED_SEARCH_POB = '';
                this.SELECTED_SEARCH_QUALIFICATIONS = '';
                this.SELECTED_SEARCH_OCCUPATIONS = '';
                this.SELECTED_SEARCH_HONOURS = '';

                this.FILTER_INDIVIDUALS();
            },
            CLICK_CURRENTPARLIAMENT: function () {
                this.$nextTick(() => {
                    let parliaments = this.$store.getters.GET_PARLIAMENTS_ORDERED;
                    let currentParliament = parliaments[0].PID;
                    if (this.SELECTED_PARLIAMENTS.includes(currentParliament)) {
                        let index = this.SELECTED_PARLIAMENTS.indexOf(currentParliament);
                        if (index > -1) {
                            this.SELECTED_PARLIAMENTS.splice(index, 1);
                        }
                    } else {
                        this.SELECTED_PARLIAMENTS.push(currentParliament);
                    }
                    this.FILTER_PARLIAMENTS();
                });
            },
            CLICK_CURRENTPARTIES: function (partyName) {
                this.$nextTick(() => {
                    if (this.SELECTED_PARTIES.includes(partyName)) {
                        let index = this.SELECTED_PARTIES.indexOf(partyName);
                        if (index > -1) {
                            this.SELECTED_PARTIES.splice(index, 1);
                        }
                    } else {
                        this.SELECTED_PARTIES.push(partyName);
                    }
                    this.FILTER_PARTIES();
                });
            },
            FILTER_PARLIAMENT_OPTIONS: function (item, queryText) {
                const pId = item.PID;
                const name = item.Name.toLowerCase();
                const searchText = queryText.toLowerCase()
                return name.indexOf(searchText) > -1 || pId.toString().indexOf(searchText) > -1;
            },
            FILTER_PARTY_OPTIONS: function (item, queryText) {
                const abbrev = item.Abbrev.toLowerCase();
                const name = item.Name.toLowerCase();
                const searchText = queryText.toLowerCase()
                return name.indexOf(searchText) > -1 || abbrev.indexOf(searchText) > -1;
            },
            FILTER_STATE_OPTIONS: function (item, queryText) {
                const abbrev = item.Abbrev.toLowerCase();
                const name = item.Name.toLowerCase();
                const searchText = queryText.toLowerCase()
                return name.indexOf(searchText) > -1 || abbrev.indexOf(searchText) > -1;
            },
            FILTER_ELECTORATE_OPTIONS: function (item, queryText) {
                const name = item.Electorate.toLowerCase();
                const searchText = queryText.toLowerCase()
                return name.indexOf(searchText) > -1 || name.indexOf(searchText) > -1;
            },

            FILTER_PARLIAMENTS: function () {
                if (this.SELECTED_PARLIAMENTS.length > 0) {
                    this.$gtag.event('filter parliamentarians - parliament', {
                        'event_category': 'filters',
                        'event_label': this.SELECTED_PARLIAMENTS.join(','),
                        'value': 1
                    });
                }
                this.parliamentSearchInput = ''
                if (this.SELECTED_PARLIAMENTS.length > 0) {
                    let alreadySelected = this.PARTIESCOPY.filter(p => this.SELECTED_PARTIES.some(sp => sp.PrimaryName === p.PrimaryName));
                    for (let i = 0; i < this.SELECTED_PARLIAMENTS.length; i++) {
                        let pId = this.SELECTED_PARLIAMENTS[i];
                        let parties = this.$store.getters.GET_PARLIAMENTS_ORDERED.find(p => p.PID === pId).PartiesByParliament;
                        let partiesList = [];
                        parties.forEach(p => partiesList.push( { PrimaryName: p.Name })); // auomatically applies a 'unique' filter when it gets passed to the component
                        partiesList.forEach(p => alreadySelected.push(p));
                    }
                    this.PARTIES = alreadySelected.sort();
                } else {
                    this.PARTIES = this.PARTIESCOPY;
                }
                return this.FILTER_INDIVIDUALS()
            },
            FILTER_PARTIES: function () {
                if (this.SELECTED_PARTIES.length > 0) {
                    this.$gtag.event('filter parliamentarians - parties', {
                        'event_category': 'filters',
                        'event_label': this.SELECTED_PARTIES.join(','),
                        'value': 1
                    });
                }
                this.partySearchInput = '';
                return this.FILTER_INDIVIDUALS()
            },

            FILTER_STATES: function () {
                if (this.SELECTED_STATES.length > 0) {
                    this.$gtag.event('filter parliamentarians - states', {
                        'event_category': 'filters',
                        'event_label': this.SELECTED_STATES.join(','),
                        'value': 1
                    });
                }
                this.stateSearchInput = '';
                return this.FILTER_INDIVIDUALS()
            },

            FILTER_ELECTORATES: function () {
                if (this.SELECTED_ELECTORATES.length > 0) {
                    this.$gtag.event('filter parliamentarians - electorates', {
                        'event_category': 'filters',
                        'event_label': this.SELECTED_ELECTORATES.join(','),
                        'value': 1
                    });
                }
                this.electorateSearchInput = '';
                return this.FILTER_INDIVIDUALS()
            },

            FILTER_OFFICEHOLDERS: function () {
                if (this.SELECTED_OFFICEHOLDERS.length > 0) {
                    this.$gtag.event('filter parliamentarians - parliamentary office holders', {
                        'event_category': 'filters',
                        'event_label': this.SELECTED_OFFICEHOLDERS.join(','),
                        'value': 1
                    });
                }
                return this.FILTER_INDIVIDUALS()
            },

            FILTER_HONOURS: function () {
                if (this.SELECTED_SEARCH_HONOURS.length > 0) {
                    this.$gtag.event('filter parliamentarians - honours', {
                        'event_category': 'filters',
                        'event_label': this.SELECTED_SEARCH_HONOURS,
                        'value': 1
                    });
                }
                return this.FILTER_INDIVIDUALS()
            },
            FILTER_MPORSENATOR: function () {
                if (this.SELECTED_MPORSENATOR.length > 0) {
                    this.$gtag.event('filter parliamentarians - member or senator', {
                        'event_category': 'filters',
                        'event_label': this.SELECTED_MPORSENATOR.join(','),
                        'value': 1
                    });
                }
                return this.FILTER_INDIVIDUALS()
            },

            FILTER_GENDER: function () {
                if (this.SELECTED_GENDER && this.SELECTED_GENDER.length > 0) {
                    this.$gtag.event('filter parliamentarians - gender', {
                        'event_category': 'filters',
                        'event_label': this.SELECTED_GENDER,
                        'value': 1
                    });
                }
                return this.FILTER_INDIVIDUALS()
            },

            FILTER_SEARCH: function () {
                if (this.SELECTED_SEARCH.length >= 3) {
                    this.$gtag.event('filter parliamentarians - search name', {
                        'event_category': 'filters',
                        'event_label': this.SELECTED_SEARCH,
                        'value': 1
                    });
                }
                return this.FILTER_INDIVIDUALS()
            },

            FILTER_SEARCH_POB: function () {
                if (this.SELECTED_SEARCH_POB.length >= 3) {
                    this.$gtag.event('filter parliamentarians - search place of birth', {
                        'event_category': 'filters',
                        'event_label': this.SELECTED_SEARCH_POB,
                        'value': 1
                    });
                }
                return this.FILTER_INDIVIDUALS()
            },

            FILTER_SEARCH_QUALIFICATIONS: function () {
                if (this.SELECTED_SEARCH_QUALIFICATIONS.length >= 3) {
                    this.$gtag.event('filter parliamentarians - search qualifications', {
                        'event_category': 'filters',
                        'event_label': this.SELECTED_SEARCH_QUALIFICATIONS,
                        'value': 1
                    });
                }
                return this.FILTER_INDIVIDUALS()
            },

            FILTER_SEARCH_OCCUPATIONS: function () {
                if (this.SELECTED_SEARCH_OCCUPATIONS.length >= 3) {
                    this.$gtag.event('filter parliamentarians - search occupations', {
                        'event_category': 'filters',
                        'event_label': this.SELECTED_SEARCH_OCCUPATIONS,
                        'value': 1
                    });
                }
                return this.FILTER_INDIVIDUALS()
            },

            currentPartyIcon: function (partyName) {
                if (this.SELECTED_PARTIES.some(p => p === partyName)) {
                    return '$vuetify.icons.checkboxOn';
                } else {
                    return '$vuetify.icons.checkboxOff';
                }
            },
        },
        watch: {
            'PAGINATION.page': function (newPage, oldPage) {
                if (typeof oldPage !== 'undefined' && newPage !== oldPage && !(this.initialLoad && newPage === 1)) {
                    this.FILTER_INDIVIDUALS();
                }
            },
            'PAGINATION.rowsPerPage': function (newSize, oldSize) {
                if (newSize !== oldSize) {
                    this.FILTER_INDIVIDUALS();
                }
            }
        },
        computed: {
            parliamentSelectLabel: function () {
                var label = 'Select a Parliament';
                if (this.$vuetify.breakpoint.name === 'xs' || this.$vuetify.breakpoint.name === 'sm') {
                    label = 'Parliament';
                }
                return label;
            },
            partySelectLabel: function () {
                var label = 'Select a Party';
                if (this.$vuetify.breakpoint.name === 'xs' || this.$vuetify.breakpoint.name === 'sm') {
                    label = 'Party';
                }
                return label;
            },
            stateSelectLabel: function () {
                var label = 'Select a State Represented';
                if (this.$vuetify.breakpoint.name === 'xs' || this.$vuetify.breakpoint.name === 'sm') {
                    label = 'State';
                }
                return label;
            },
            electorateSelectLabel: function () {
                var label = 'Select an Electorate Represented';
                if (this.$vuetify.breakpoint.name === 'xs' || this.$vuetify.breakpoint.name === 'sm') {
                    label = 'Electorate';
                }
                return label;
            },
            nameSearchLabel: function () {
                var label = 'Name search (3 characters or more)';
                if (this.$vuetify.breakpoint.name === 'xs' || this.$vuetify.breakpoint.name === 'sm') {
                    label = 'Name search';
                }
                return label;
            },
            pobSearchLabel: function () {
                var label = 'Place of Birth search (3 characters or more)';
                if (this.$vuetify.breakpoint.name === 'xs' || this.$vuetify.breakpoint.name === 'sm') {
                    label = 'Place of Birth search';
                }
                return label;
            },
            qualificationsSearchLabel: function () {
                var label = 'Qualifications search (3 characters or more)';
                if (this.$vuetify.breakpoint.name === 'xs' || this.$vuetify.breakpoint.name === 'sm') {
                    label = 'Qualifications search';
                }
                return label;
            },
            occupationsSearchLabel: function () {
                var label = 'Occupations search (3 characters or more)';
                if (this.$vuetify.breakpoint.name === 'xs' || this.$vuetify.breakpoint.name === 'sm') {
                    label = 'Occupations search';
                }
                return label;
            },
            officeholdersSearchLabel: function () {
                var label = 'Select a Parliamentary Office';
                if (this.$vuetify.breakpoint.name === 'xs' || this.$vuetify.breakpoint.name === 'sm') {
                    label = 'Parliamentary Office';
                }
                return label;
            },
            honoursSearchLabel: function () {
                var label = 'Select an Honour';
                if (this.$vuetify.breakpoint.name === 'xs' || this.$vuetify.breakpoint.name === 'sm') {
                    label = 'Honours search';
                }
                return label;
            },
            currentParliamentIcon: function () {
                let parlArray = this.$store.getters.GET_PARLIAMENTS_ORDERED;
                let currentParliament = parlArray[0].PID;
                if (this.SELECTED_PARLIAMENTS.indexOf(currentParliament) > -1) {
                    return '$vuetify.icons.checkboxOn';
                } else {
                    return '$vuetify.icons.checkboxOff';
                }
            },
            currentParliamentValue: function () {
                let parlArray = this.$store.getters.GET_PARLIAMENTS_ORDERED;
                if (this.SELECTED_PARLIAMENTS.includes(parlArray[parlArray.length - 1].PID)) {
                    return parlArray[parlArray.length - 1].PID;
                } else {
                    return false;
                }
            },
            filteredHonours: function () {
                const periodAtEnd = /\.$/;
                const fullDateAtEndRegex = /\d{2}\.\d{1,2}\.\d{4}$/;
                const yearRange = /from \d{4} to \d{4}$/;
                const yearAtEndRegex = /\d{4}$/;
                const commaAtEndRegex = /,$/;
                const regexes = [periodAtEnd, yearRange, fullDateAtEndRegex, yearAtEndRegex, commaAtEndRegex];
                let honours = this.HONOURS;
                regexes.forEach(r => {
                    honours = honours.map(h => h.trim().replace(r, ''));
                });
                honours = honours.map(h => h.trim());
                return [...new Set(honours)];
            },
            searchMore: function () {
                return this.SELECTED_SEARCH_MORE ? 'searchMore_show' : 'searchMore_hide'
            },
            moreButtonIcon: function () {
                return this.SELECTED_SEARCH_MORE ? 'buttonIcon rotate' : 'buttonIcon';
            },
            moreButtonText: function () {
                return this.SELECTED_SEARCH_MORE ? 'Filter' : 'Filter';
            },
            csvDownloadIcon() {
                return this.csvDownloading ? 'cached' : 'text_snippet';
            },
            csvDownloadClass() {
                let csvClass = 'mr-1';
                if (this.csvDownloading) {
                    csvClass = csvClass + ' loading'
                }
                return csvClass;
            }
        },
    }
</script>
<style scoped>

    .handbook-searchOptions_card {
        margin-bottom: 6px;
    }

    .handbook_toggleButton {
        width: 100%;
        height: 100%;
    }

        .handbook_toggleButton > span.v-tooltip {
            display: none;
        }

    .handbook_button {
        min-height: 35px;
        height: 100%;
    }

    @media  (max-width: 599px) {
        .handbook_toggleButton .handbook_button {
            width: 50% !important;
        }
    }

    .handbook_iconButton {
        min-height: 35px;
        width: 100%;
        margin-left: 2px;
        margin-top: 0;
        height: 100%;
    }

    .handbook-toolbar {
        background-color: #f5f5f5;
    }

    .searchMore_hide {
          display:none;
        opacity: 0;
        transition: opacity 0.2s linear;
        height: 0;
        padding: 0 !important;
    }

    .searchMore_show {
        display:block;
        opacity: 1;
        transition: opacity 0.4s linear;
    }

    .chamberButton {
        color: #f5f5f5;
    }

    .buttonIcon {
        transform: rotate(0deg);
        transition: transform 0.2s linear !important;
    }

        .buttonIcon.rotate {
            transform: rotate(135deg);
            transition: transform 0.2s linear !important;
        }

    .handbook-iteratorCard {
        padding: 5px;
    }

    @media only screen and (min-width: 960px) {

        .handbook-leftDivider_hideSmall {
            border-left: 1px solid rgba(0,0,0,0.2)
        }
    }

    @media screen and (max-width: 959px) {
        .short-button-text {
            display: none !important;
        }

        .long-button-text {
            display: inline !important;
            color: #f5f5f5;
        }
    }

    @media screen and (min-width: 960px) and (max-width: 1260px) {

        .buttonIcon {
            display: inline !important;
        }

        .hideButtonText {
            display: none !important;
        }

        .short-button-text {
            display: inline !important;
        }

        .long-button-text {
            display: none !important;
        }
    }

    @media screen and (min-width: 1261px) {
        .short-button-text {
            display: none !important;
        }

        .long-button-text {
            display: inline !important;
        }
    }
</style>

<style lang="stylus" scoped>
    @media  (max-width: 599px) {
    .handbook-searchOptions_card >>> .v-text-field {
        padding-top: 4px !important;
        margin-top: 4px;
    }
}
</style>

